import { PolicyDetailsV2 } from "@hagerty/customer-insurance-gateway-client";

import { mockPolicies, MockPolicyId } from "../mockPolicies";

export const getMockPolicies = (...policyNumbers: MockPolicyId[]): PolicyDetailsV2[] =>
  policyNumbers.map((policyNumber) => mockPolicies[policyNumber]);
